<template>
<div id="page-notificaciones" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="notifications" title="Notificaciones Recibidas" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="botonAgregar" fab dark color="primary" slot="activator" @click.native="redirectToNotification()" title="Nueva Notificación" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-spacer></v-spacer>
                            <v-btn v-if="notificaciones.items.length>0" small outlined dark color="info" @click.native="marcarTodas()" title="Marcar todas como leídas" v-tippy>
                                <v-icon dark>done_all</v-icon>&nbsp;Marcar todas como leídas
                            </v-btn><br/>
                            <v-client-table ref="vuetable" :data="notificaciones.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                                </template>

                                <template slot="mensaje" slot-scope="props" >
                                    <div class="columnaMensaje" >{{ getDataMesagge(props.row.mensaje, true) }}
                                    <a @click="
                                        downloadReport(getDataMesagge(props.row.mensaje, false), props.row.tipo)
                                        " class="primary--text" title="Descargar" v-tippy v-if="isDownload(props.row.mensaje)" >
                                        <i class="fa fa-download" style="margin-left: 10px" ></i>
                                    </a></div>
                                </template>

                                <template slot="fecha" slot-scope="props" >
                                    <span>{{ formatFecha(props.row.fecha) }}</span>
                                </template>

                                <template slot="estatus" slot-scope="props" >
                                    <span>{{
                      props.row.estatus == 0 ? "No leido" : "Leido"
                    }}</span>
                                </template>

                                <template slot="actions" slot-scope="props" >

                                    <v-btn fab dark x-small color="blue" @click.native="markRead(props.row.id_notificacion)" title="Marcar como leído" v-tippy v-show="mostrarOpcion(props.row)" >
                                        <v-icon>check</v-icon>
                                    </v-btn>

                                </template>
                            </v-client-table>
                        </div>

                        <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >add</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Nueva Notificación</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="tipo" label="Tipo" type="text" v-model="model.tipo" :rules="[rules.required]" maxlength="50" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="titulo" label="Título" type="text" v-model="model.titulo" :rules="[rules.required]" maxlength="200" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="mensaje" label="Mensaje" type="text" v-model="model.mensaje" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-autocomplete v-model="model.usuarios" :items="usuarios" :hide-no-data="true" multiple chips deletable-chips :hide-selected="true" :return-object="false" ref="selectUsuario" :item-text="concatenaUsuario" item-value="id_usuario" label="Selecciona un Usuario" :rules="[rules.required]" ></v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>Enviar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
export default {
    created: function () {
        this.getNotificaciones();
        this.getUsuarios();
        /*(this.$options.sockets.onmessage = data => {
            var data = JSON.parse(data.data);
            let notificacion = data["notificacion"];

            if (notificacion != undefined)
                if (notificacion.usuario == this.$local_storage.get("id_usuario"))
                    this.getNotificaciones();
        }),*/
        (this.botonAgregar =
            this.$local_storage.get("tipo_usuario") == "Super Usuario" ||
            this.$local_storage.get("tipo_usuario") == "Soporte");             
    },
    data() {
        return {
            fab: false,
            name: "datagrid",
            modal: false,
            loading: false,
            botonAgregar: false,
            columns: ["titulo", "mensaje", "tipo", "fecha", "estatus", "actions"],
            show_loading: true,
            options: {
                filterable: ["titulo", "mensaje", "tipo", "fecha", "estatus"],
                sortable: ["titulo", "mensaje", "tipo", "fecha", "estatus"],
                headings: {
                    actions: "Operaciones"
                },
                listColumns: {
                    estatus: [{
                            id: 1,
                            text: "Leído"
                        },
                        {
                            id: 0,
                            text: "No Leído"
                        },
                        {
                            id: null,
                            text: "Todos"
                        }
                    ]
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Notificaciones",
                    disabled: true,
                    href: ""
                }
            ],
            model: {
                tipo: "",
                mensaje: "",
                titulo: "",
                usuarios: []
            },
            usuarios: [],
            rules: {
                required: v => !!v || "Este campo es requerido"
            },
            notificaciones: {
                selected: [],
                headers: [{
                        text: "Notificación",
                        value: "nombre"
                    },
                    {
                        text: "Operaciones",
                        value: "operaciones",
                        align: "center"
                    }
                ],
                items: []
            }
        };
    },
    methods: {
        mostrarOpcion: function(row){  
            var tipoUsuario = this.$local_storage.get("tipo_usuario");             
            if(row.aviso_rfc == 1){
                if(tipoUsuario == "Super Usuario" || tipoUsuario == "Soporte" || tipoUsuario == "Grupo")//Solo super, grupo y soporte pueden marcar leido un aviso que se muestra al iniciar sesión
                    return true;
                else 
                    return false;
            }else if(row.estatus ==0){
                return true;            
            } else {
                return false;
            }
        },
        isDownload: function (message) {
            try {
                let mess = JSON.parse(message);

                return true;
            } catch (e) {
                return false;
            }
        },
        getDataMesagge: function (message, flag_id) {
            try {
                let mess = JSON.parse(message);

                if (!flag_id) return mess.file;
                else return mess.texto;
            } catch (e) {
                return message;
            }
        },
        downloadReport: function (id, tipo) {
            let name = id.split("/");
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

           let data= {
                        id: id
                    };
            if(tipo !='Alerta')
            data= {
                    id: id,
                    bucket: "descargas.econnectpro.mx"
             };
            axios
                .post(
                    this.$hostname + "s3/download_url/",data,
                    /*{
                      "Content-type": "application/json",
                      "Access-Control-Allow-Origin": "*",
                      Allow: "POST",
                      "cache-control": "no-cache",
                      responseType: "arraybuffer"
                    }*/
                )
                .then(res => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        //a.download = name[name.length - 1];
                        a.click();
                        a.parentNode.removeChild(a);

                        this.modalFactura = false;
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch(error => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        openModal: function (type) {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.usuarios = [];
            this.modal = true;
        },

        redirectToNotification: function () {
            this.$local_storage.set("redirectFromNotificaciones", 1);
            this.$router.push("/notificaciones/enviadas");
        },

        formatFecha: function (fecha) {
            var date = fecha.substr(0, 10);
            date = date.split("-");

            return date[2] + "/" + date[1] + "/" + date[0];
        },
        getNotificaciones: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let id_usuario = this.$local_storage.get("id_usuario");

            axios
                .post(this.$hostname + "notificaciones/list_notificaciones/", {
                    usuario: id_usuario
                })
                .then(response => {
                    this.notificaciones.items = response.data;
                    this.notificaciones.items.sort(function(a, b) {
                        //Ordenar por fecha más reciente
                        return new Date(b.fecha) - new Date(a.fecha);
                    });
                    var filter = this.notificaciones.items.filter(function (item) {
                        return item.estatus == 0;
                    });
                    this.$root.$emit("notificationsUpdate", filter.length);
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener las notificaciones.",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        markRead: function (id_notificacion) {
            let id_usuario = this.$local_storage.get("id_usuario");
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .put(this.$hostname + "notificaciones/mark_as_read/", {
                    usuario: id_usuario,
                    id_notificacion: id_notificacion
                })
                .then(response => {
                    this.getNotificaciones();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al marcar como leído",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },
        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else if (this.model.usuarios.length <= 0) {
                this.$swal({
                    position: "center",
                    type: "warning",
                    title: "Advertencia!",
                    text: "Debe seleccionar al menos un usuario"
                });
                this.$nextTick(() => this.$refs.selectUsuario.focus());
                return false;
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                axios
                    .post(this.$hostname + "notificaciones/create_notificacion/", datos)
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                    })
                    .then(() => {
                        this.getNotificaciones();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },
        getUsuarios: function () {
            let id_usuario = this.$local_storage.get("id_usuario");
            axios
                .get(this.$hostname + "usuarios/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        var filter = res.data.filter(function (item) {
                            return item.estatus == true && item.id_usuario != id_usuario;
                        });
                        this.usuarios = filter;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        marcarTodas: function(){   
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');  
            
            //Marca todas, excepto las de aviso_rfc:1, esto significa que es una notificación que se muestra al iniciar sesión y que se envió seleccionando RFC
            //ya que estas solo las puede marcar un super, soporte o grupo
            var urlMark = this.$hostname + "notificaciones/mark_all/";

            var tipoUsuario = this.$local_storage.get("tipo_usuario"); 
            if(tipoUsuario == "Super Usuario" || tipoUsuario == "Soporte" || tipoUsuario == "Grupo")           
                urlMark = this.$hostname + "notificaciones/mark_all_super/";//Marca incluso las de aviso_rfc:1

            axios.post(urlMark, {usuario:this.$local_storage.get("id_usuario")})
            .then(res => {
                this.getNotificaciones();
                this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "Los registros se actualizaron correctamente.",
                    footer: ""
                });
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al actualizar las notificaciones.",
                    footer: ""
                });
                console.log(err);
                this.$root.$dialogLoader.hide();
            });
        },
        concatenaUsuario: item =>
            item.nombre + " " + item.apellidos + " (" + item.username + ")"
    }
};
</script>
<style scoped>
.elevation-2 >>> .columnaMensaje {
    white-space: normal !important;
    max-width: 350px !important;
    text-align: justify !important;
}
</style>